import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useContext, useId, useSignal, useTask$, $, Slot } from "@builder.io/qwik";
import "../checkbox/checkbox-root.qwik.mjs";
import "../checkbox/checkbox-indicator.qwik.mjs";
import "../checklist/checklist-root.qwik.mjs";
import "../checklist/checklist-selectall.qwik.mjs";
import "../checklist/checklist-item.qwik.mjs";
import "../checklist/checklist-indicator.qwik.mjs";
import "../accordion/accordion-root.qwik.mjs";
import "../accordion/accordion-item.qwik.mjs";
import "../accordion/accordion-trigger.qwik.mjs";
import "../accordion/accordion-content.qwik.mjs";
import "../accordion/accordion-heading.qwik.mjs";
import "../carousel/root.qwik.mjs";
import "../carousel/scroller.qwik.mjs";
import "../carousel/slide.qwik.mjs";
import "../carousel/previous.qwik.mjs";
import "../carousel/next.qwik.mjs";
import "../carousel/pagination.qwik.mjs";
import "../carousel/bullet.qwik.mjs";
import "../carousel/title.qwik.mjs";
import "../carousel/player.qwik.mjs";
import "../carousel/stepper.qwik.mjs";
import "../carousel/step.qwik.mjs";
import "../collapsible/collapsible.qwik.mjs";
import "../collapsible/collapsible-content.qwik.mjs";
import "../collapsible/collapsible-trigger.qwik.mjs";
import "../label/label.qwik.mjs";
import "../modal/modal-root.qwik.mjs";
import "../modal/modal-panel.qwik.mjs";
import "../modal/modal-content.qwik.mjs";
import "../modal/modal-footer.qwik.mjs";
import "../modal/modal-header.qwik.mjs";
import "../modal/modal-title.qwik.mjs";
import "../modal/modal-description.qwik.mjs";
import "../modal/modal-trigger.qwik.mjs";
import "../modal/modal-close.qwik.mjs";
import "../pagination/pagination.qwik.mjs";
import "../popover/popover-root.qwik.mjs";
import "../popover/popover-trigger.qwik.mjs";
import "../popover/popover-panel.qwik.mjs";
import "../popover/popover-panel-arrow.qwik.mjs";
import { isBrowser, isServer } from "@builder.io/qwik/build";
import "../select/select-root.qwik.mjs";
import "../select/select-item.qwik.mjs";
import "../select/select-item-label.qwik.mjs";
import "../select/select-error-message.qwik.mjs";
import "../select/select-label.qwik.mjs";
import "../select/select-trigger.qwik.mjs";
import "../select/select-display-value.qwik.mjs";
import "../select/select-popover.qwik.mjs";
import "../select/select-listbox.qwik.mjs";
import "../select/select-group.qwik.mjs";
import "../select/select-group-label.qwik.mjs";
import "../select/select-item-indicator.qwik.mjs";
import "../select/select-description.qwik.mjs";
import "../select/hidden-select.qwik.mjs";
import "../progress/progress-indicator.qwik.mjs";
import "../progress/progress-root.qwik.mjs";
import "../separator/separator.qwik.mjs";
import "../tabs/tabs.qwik.mjs";
import "../tabs/tab-panel.qwik.mjs";
import "../tabs/tabs-list.qwik.mjs";
import "../tabs/tab.qwik.mjs";
import { HToggle } from "../toggle/toggle.qwik.mjs";
import "./toggle-group-root.qwik.mjs";
import "../../utils/visually-hidden.qwik.mjs";
import "../tooltip/tooltip-root.qwik.mjs";
import "../tooltip/tooltip-panel.qwik.mjs";
import "../tooltip/tooltip-trigger.qwik.mjs";
import "../tooltip/tooltip-arrow.qwik.mjs";
import "../dropdown/dropdown-root.qwik.mjs";
import "../dropdown/dropdown-item.qwik.mjs";
import "../dropdown/dropdown-radio-item.qwik.mjs";
import "../dropdown/dropdown-checkbox-item.qwik.mjs";
import "../dropdown/dropdown-trigger.qwik.mjs";
import "../dropdown/dropdown-content.qwik.mjs";
import "../dropdown/dropdown-separator.qwik.mjs";
import "../dropdown/dropdown-item-indicator.qwik.mjs";
import "../dropdown/dropdown-radio-group.qwik.mjs";
import "../dropdown/dropdown-popover.qwik.mjs";
import "../dropdown/dropdown-group.qwik.mjs";
import "../dropdown/dropdown-group-label.qwik.mjs";
import "../combobox/combobox-root.qwik.mjs";
import "../combobox/combobox-item.qwik.mjs";
import "../combobox/combobox-item-label.qwik.mjs";
import "../combobox/combobox-empty.qwik.mjs";
import "../combobox/combobox-error-message.qwik.mjs";
import "../combobox/combobox-label.qwik.mjs";
import "../combobox/combobox-trigger.qwik.mjs";
import "../combobox/combobox-input.qwik.mjs";
import "../combobox/combobox-listbox.qwik.mjs";
import "../combobox/combobox-group.qwik.mjs";
import "../combobox/combobox-group-label.qwik.mjs";
import "../combobox/combobox-item-indicator.qwik.mjs";
import "../combobox/combobox-description.qwik.mjs";
import "../combobox/combobox-popover.qwik.mjs";
import "../combobox/combobox-control.qwik.mjs";
import "../combobox/combobox-hidden-select.qwik.mjs";
import "../combobox/combobox-inline.qwik.mjs";
import "../polymorphic/polymorphic.qwik.mjs";
import { toggleGroupRootApiContextId } from "./toggle-group-context.qwik.mjs";
const keyNavigationMap = {
  horizontal: {
    ltr: {
      ArrowRight: 1,
      ArrowLeft: -1,
      ArrowDown: 0,
      ArrowUp: 0
    },
    rtl: {
      ArrowRight: -1,
      ArrowLeft: 1,
      ArrowDown: 0,
      ArrowUp: 0
    }
  },
  vertical: {
    ltr: {
      ArrowDown: 1,
      ArrowUp: -1,
      ArrowRight: 0,
      ArrowLeft: 0
    },
    rtl: {
      ArrowDown: -1,
      ArrowUp: 1,
      ArrowRight: 0,
      ArrowLeft: 0
    }
  }
};
const HToggleGroupItem = component$((props) => {
  const { value, disabled: itemDisabled = false, ...itemProps } = props;
  const rootApiContext = useContext(toggleGroupRootApiContextId);
  const disabled = rootApiContext.rootIsDisabled || itemDisabled;
  const itemId = useId();
  const isPressedSig = useSignal(false);
  const itemRef = useSignal();
  const itemTabIndex = useSignal(isPressedSig.value ? 0 : -1);
  const itemSig = useSignal(() => ({
    itemId,
    isPressed: isPressedSig,
    isDisabled: disabled,
    ref: itemRef,
    tabIndex: itemTabIndex
  }));
  useTask$(async ({ track }) => {
    const pressedValue = track(() => rootApiContext.pressedValuesSig.value);
    if (pressedValue == null) {
      itemSig.value.isPressed.value = false;
      return;
    }
    if (typeof pressedValue === "string") {
      itemSig.value.isPressed.value = pressedValue === value;
    } else {
      itemSig.value.isPressed.value = pressedValue.includes(value);
    }
  });
  useTask$(async () => {
    await rootApiContext.registerItem$(itemId, itemSig);
    const allItems = await rootApiContext.getAllItem$();
    if (isBrowser)
      return;
    const currentPressedItems = allItems.filter((item) => item.isPressed.value === true);
    if (currentPressedItems.length > 0) {
      return currentPressedItems.forEach(async (item) => {
        await rootApiContext.getAndSetTabIndexItem$(item.itemId, 0);
      });
    }
    const firstNotDisabledItem = allItems.find((item) => item.isDisabled === false);
    if (firstNotDisabledItem !== void 0) {
      await rootApiContext.getAndSetTabIndexItem$(firstNotDisabledItem.itemId, 0);
    }
  });
  useTask$(async ({ track }) => {
    if (isServer)
      return;
    track(() => itemRef.value);
    if (!itemRef.value)
      return;
    rootApiContext.itemsCSR.value = [
      ...rootApiContext.itemsCSR.value,
      itemRef.value
    ];
    if (rootApiContext.itemsCSR.value.length === (await rootApiContext.getAllItem$()).length) {
      const allItems = rootApiContext.itemsCSR.value;
      const currentPressedItems = allItems.filter((item) => item.ariaPressed === "true");
      if (currentPressedItems.length > 0) {
        return currentPressedItems.forEach(async (item) => {
          const itemRef2 = allItems.find((i) => i.id === item.id);
          if (!itemRef2)
            throw "Item Not Found";
          itemRef2.tabIndex = 0;
        });
      }
      const firstNotDisabledItem = allItems.find((item) => item.ariaDisabled === "false");
      if (firstNotDisabledItem !== void 0) {
        firstNotDisabledItem.tabIndex = 0;
      }
    }
  });
  const handlePressed$ = $((pressed) => {
    if (pressed) {
      rootApiContext.activateItem$(value);
    } else {
      rootApiContext.deActivateItem$(value);
    }
  });
  const handleKeyDown$ = $(async (event) => {
    const items = Array.from(document.querySelectorAll(`.toggle-group-item-${rootApiContext.rootId}`));
    if (items.length === 0)
      return;
    const enabledItems = items.filter((item) => item.ariaDisabled === "false");
    const currentElement = event.target;
    const currentIndex = enabledItems.findIndex((e) => e.id === currentElement.id);
    if (currentIndex === -1)
      return;
    const direction = keyNavigationMap[rootApiContext.rootOrientation][rootApiContext.rootDirection][event.key];
    if (direction !== 0) {
      let nextIndex = currentIndex + direction;
      if (rootApiContext.rootIsLoopEnabled) {
        nextIndex = (currentIndex + direction + enabledItems.length) % enabledItems.length;
      } else {
        if (nextIndex >= enabledItems.length)
          nextIndex = enabledItems.length - 1;
        if (nextIndex < 0)
          nextIndex = 0;
      }
      enabledItems[nextIndex]?.focus();
    }
  });
  return /* @__PURE__ */ jsx(HToggle, {
    ref: itemRef,
    ...itemProps,
    "bind:pressed": itemSig.value.isPressed,
    disabled,
    onPressedChange$: handlePressed$,
    onKeyDown$: handleKeyDown$,
    class: `toggle-group-item-${rootApiContext.rootId} ${props.class}`,
    id: itemId,
    tabIndex: itemSig.value.tabIndex.value,
    "aria-orientation": rootApiContext.rootOrientation,
    dir: rootApiContext.rootDirection,
    "data-qui-togglegroup-item": true,
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HToggleGroupItem
};
